const TechnicalRU5 = () => {
    return (
        <div>
            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p>&nbsp;</p>

            <p><span style={ { color: "#000000" } }><strong>КОЭФФИЦИЕНТ ТОПЛИВНОЙ ЭФФЕКТИВНОСТИ</strong></span></p>

            <p>&nbsp; &nbsp; &nbsp;<span style={ { color: "#000000" } }>Одной из сил, влияющих на коэффициент эффективности использования топлива моторизованными транспортными средствами, является сопротивление качению.</span></p>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td><img alt="" src="http://www.rubbers.lv/upload/pictures/200/content_content_reifenlabel_001.png" style={ { height: "167px", width: "89px" } } />Новая маркировка шин ЕС содержит показатель сопротивления шин качению, где отметка &bdquo;A&rsquo;&rsquo; соответствует высшему коэффициенту топливной эффективности, а &bdquo;G&rsquo;&rsquo; - низшему. Черная стрелка (в данном случае B) рядом со шкалой уровней указывает на общий уровень качества изделия.</td>
                        <td>
                        <p>&nbsp;</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td><img alt="" src="http://www.rubbers.lv/upload/pictures/202/content_content__E5BC360186E3162C00B53D68FBB4C924508D4B8CBA38854F53_pimgpsh_fullsize_distr.png" style={ { height: "150px", width: "217px" } } />Различия&nbsp;между,&nbsp;с&nbsp;&quot;A&quot;&nbsp;категории&nbsp;и&nbsp;категории&nbsp;G&nbsp;шины,&nbsp;шины,&nbsp;а&nbsp;вплане&nbsp;экономии&nbsp;топлива&nbsp;-&nbsp;до&nbsp;7,5%.</td>
                    </tr>
                </tbody>
            </table>

            <p>&nbsp;</p>

            <p><span style={ { color: "#000000" } }><strong>СЦЕПЛЕНИЕ С ВЛАЖНОЙ ПОВЕРХНОСТЬЮ</strong></span></p>

            <p>&nbsp; &nbsp; <span style={ { color: "#000000" } }>&nbsp;Важнейшее назначение шин &ndash; гарантия безопасности в любых условиях. Сцепление с влажной дорожной поверхностью относится к важнейшим показателям качества шины.</span></p>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td><img alt="" src="http://www.rubbers.lv/upload/pictures/201/content_content_reifenlabel_003.png" style={ { height: "213px", width: "85px" } } />
                        <p>Однако, термины &bdquo;улучшенное сцепление&rdquo; и &bdquo;замедленное качение&rdquo; вступают в известное противоречие и требуют определенного компромисса в плане качества. Но новая регула ЕС о маркировке шин позволит нашим клиентам оценить и выбрать оптимальный для себя вариант.</p>

                        <p>Обозначение будет иметь форму 7-уровневой шкалы от &bdquo;A&rsquo;&rsquo; (наибольший уровень сцепления) до &bdquo;G&rdquo; (наименьший уровень).</p>

                        <p>&nbsp;</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td><img alt="" src="http://www.rubbers.lv/upload/pictures/203/content_content_wet-braking_tcm2232-115115.jpg" style={ { height: "150px", width: "370px" } } />
                        <p>Чрезвычайная&nbsp;ситуация&nbsp;несколько&nbsp;метров&nbsp;можно&nbsp;решить&nbsp;все.Машина&nbsp;с&nbsp;A&nbsp;оценки&nbsp;шины,&nbsp;останавливается&nbsp;на&nbsp;30%&nbsp;быстрее,&nbsp;</p>

                        <p>чемавтомобиль&nbsp;с&nbsp;F&nbsp;оценки&nbsp;шинах.</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>&nbsp;</p>

            <p><span style={ { color: "#000000" } }><strong>ШУМНОСТЬ</strong></span></p>

            <p><span style={ { color: "#000000" } }>Уровень&nbsp;шума&nbsp;при&nbsp;качении&nbsp;шины часть&nbsp;из&nbsp;них&nbsp;&nbsp;создают&nbsp;шума.</span></p>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td>
                        <p><img alt="" src="http://www.rubbers.lv/upload/pictures/204/content_content_reifenlabel_004.png" style={ { height: "85px", width: "188px" } } />Уровень внешнего шума разделен на 3 категории, измеряется в децибелах (dB) и сопровождается изображением одной, двух или трех звуковых волн.</p>

                        <p>Шум при движении &ndash; очень важный экологический показатель. Он определяется с учетом ряда критериев:<br />
                        &bull; Интенсивность движения<br />
                        &bull; Стиль вождения<br />
                        &bull; Взаимодействие шины-дорога</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table border="1" cellPadding="1" cellSpacing="1" style={ { width: "500px" } }>
                <tbody>
                    <tr>
                        <td>
                        <p><img alt="" src="http://www.rubbers.lv/upload/pictures/205/content_content_noiseExplained_tcm2094-115361.png" style={ { height: "200px", width: "247px" } } /><strong><span style={ { color: "#000000" } }>1 черная звуковая волна</span>&nbsp;</strong>= 3dB, или ниже будущего, более жесткого европейского уровня.<br />
                        <span style={ { color: "#000000" } }><strong>2 черные звуковые волны</strong></span><strong>&nbsp;</strong>= или почти равно будущему европейскому уровню.<br />
                        <span style={ { color: "#000000" } }><strong>3 черные звуковые волны</strong></span>&nbsp;= равно будущему европейскому уровню.</p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>&nbsp;</p>

        </div>
    );
};

export default TechnicalRU5;


